import { render, staticRenderFns } from "./Women.vue?vue&type=template&id=6c49e0f9&scoped=true&"
import script from "./Women.vue?vue&type=script&lang=js&"
export * from "./Women.vue?vue&type=script&lang=js&"
import style0 from "./Women.vue?vue&type=style&index=0&id=6c49e0f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49e0f9",
  null
  
)

export default component.exports